var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category photo category--skeleton"},[_c('Skeleton',{attrs:{"width":"100%","height":"100%","borderRadius":"8px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }